import classNames from 'classnames';
import { Tooltip } from 'react-tooltip';
import type { PlacesType } from 'react-tooltip';

import QuickTip from './quick-tip';

import { useFeatureHints } from './feature-hints-context';

import {
  FEATURE_HINT_TARGET_ATTR,
  FEATURE_HINTS_TOOLTIP_ID,
  FEATURE_HINTS_TOOLTIP_Z_INDEX_CLASS,
} from './feature-hints.constants';
import { colors } from 'src/design-tokens/primitives';

const FeatureHintsTooltip = () => {
  const { activeId, activeStep, currentStep, totalSteps, isLast, next, close } =
    useFeatureHints();
  const anchorId = activeStep?.tooltipAnchorId ?? activeId;

  return (
    <Tooltip
      id={FEATURE_HINTS_TOOLTIP_ID}
      isOpen={activeId !== null}
      imperativeModeOnly
      clickable
      positionStrategy="fixed"
      role="dialog"
      aria-label={activeStep?.title}
      anchorSelect={
        anchorId ? `[${FEATURE_HINT_TARGET_ATTR}="${anchorId}"]` : undefined
      }
      place={(activeStep?.placement ?? 'bottom') as PlacesType}
      offset={12}
      className={classNames(
        '!bg-navy-50 !rounded-xl !p-5 !w-96 !max-w-96 !opacity-100 [&>div]:!p-0',
        FEATURE_HINTS_TOOLTIP_Z_INDEX_CLASS
      )}
      border={`1px solid ${colors.navy[200]}`}
      arrowColor={colors.navy[50]}
      render={() => {
        if (!activeStep) {
          return null;
        }

        return (
          <QuickTip
            title={activeStep.title}
            body={activeStep.body}
            currentStep={currentStep}
            totalSteps={totalSteps}
            isLast={isLast}
            onNext={next}
            onSkip={close}
          />
        );
      }}
    />
  );
};

export default FeatureHintsTooltip;
